import { UserInfo, UserTrii } from "@trii/types/dist/Users";

export const resolveUserLabel = ({
  userId,
  users,
  currentUser,
}: {
  userId?: string;
  users: UserInfo[];
  currentUser?: UserTrii | null;
}) => {
  if (!userId) return null;
  if (currentUser?.uid && currentUser.uid === userId) {
    return currentUser.display_name || currentUser.email || null;
  }
  const fromUsers = users.find((u) => u?.id === userId);
  return fromUsers?.name?.trim() || fromUsers?.email || null;
};
